import { render, staticRenderFns } from "./modalQuestion.vue?vue&type=template&id=358dcb46&scoped=true&lang=pug&"
import script from "./modalQuestion.vue?vue&type=script&lang=js&"
export * from "./modalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./modalQuestion.vue?vue&type=style&index=0&id=358dcb46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358dcb46",
  null
  
)

export default component.exports